import * as Sentry from '@sentry/react';

import { defaultQueryClient } from 'hb-react/shared/providers/QueryClient';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { type URLObject } from './types';

export default (URL: URLObject) =>
  defaultQueryClient.fetchQuery({
    queryKey: [URL.path, URL.params],
    queryFn: async () => {
      try {
        const response = await axios.get(URL.path, {
          params: URL.params,
        });

        return { id: URL.objectKey, data: { ...response.data } };
      } catch (error) {
        Sentry.captureException(error);

        throw error;
      }
    },
    staleTime: 5000,
    retry: 3,
    // 3 seconds between retries
    retryDelay: 3000,
  });
